import React from "react"
class Contest extends React.Component
{
    epochToLocal(seconds)
    {
        const d = new Date(0)
        d.setUTCSeconds(seconds);
        return d;
    }
    
    render()
    {
        const name = this.props.name;
        const time = this.props.time;
        const processed_time = this.epochToLocal(time).toLocaleString()
        return(
            <div>
            <span style={{fontFamily:"raleway"}}>{name}</span>   
            <p>{processed_time}</p>
            </div>
        )
    }
}
export default Contest;